import { useSetDateFnsDefaults } from 'state/hooks/useSetDateFnsDefaults';

import { useSetDataFromURL } from 'shared/utils/setDataFromURL';

const InitDefaults = () => {
  useSetDataFromURL();
  useSetDateFnsDefaults();

  return null;
};

export default InitDefaults;
